import { createContext, useContext, ReactNode } from "react";

import { AutocompleteGetTagProps } from "@mui/material/useAutocomplete";

import { ChipShape, ChipVariant } from "../DashboardChip/types";

import { AutocompleteOption } from "./types";

export interface AutocompletePaperContextValue {
  multiple: boolean;
  internalValue: unknown;
  syncedInternalValue?: unknown;
  internalIsOpen: boolean;
  usingSubmitPattern?: boolean;
  externalRenderTags?: (
    value: (string | AutocompleteOption)[],
    getTagProps: AutocompleteGetTagProps
  ) => React.ReactNode;
  onApply: () => void;
  onClear: () => void;
  onRemoveTag: (option: string | AutocompleteOption) => void;
  chipProps?: { shape: ChipShape; variant: ChipVariant };
}

const AutocompletePaperContext = createContext<AutocompletePaperContextValue | null>(null);

export const useAutocompletePaperContext = () => {
  const context = useContext(AutocompletePaperContext);
  if (!context) {
    throw new Error("useAutocompletePaperContext must be used within an AutocompletePaperProvider");
  }
  return context;
};

interface AutocompletePaperProviderProps extends AutocompletePaperContextValue {
  children: ReactNode;
}

export const AutocompletePaperProvider = ({
  children,
  multiple,
  internalValue,
  syncedInternalValue,
  internalIsOpen,
  usingSubmitPattern,
  externalRenderTags,
  onApply,
  onClear,
  onRemoveTag,
  chipProps,
}: AutocompletePaperProviderProps) => {
  return (
    <AutocompletePaperContext.Provider
      value={{
        multiple,
        internalValue,
        syncedInternalValue,
        internalIsOpen,
        usingSubmitPattern,
        externalRenderTags,
        onApply,
        onClear,
        onRemoveTag,
        chipProps,
      }}
    >
      {children}
    </AutocompletePaperContext.Provider>
  );
};
